import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ActionSelectorPage } from "./action-selector.page";
import { TranslateModule } from "@ngx-translate/core";
import { ToActionModule } from "src/app/pipes/to-action/to-action.module";
import { ActionParamsInfoModule } from "src/app/components/action-params-info/action-params-info.module";

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslateModule, ToActionModule, ActionParamsInfoModule],
  declarations: [ActionSelectorPage],
})
export class ActionSelectorPageModule {}
